import React, { useReducer, useState } from 'react';
import styles from './index.module.scss';

// Components
import { Modal, Form, Button } from 'react-bootstrap';
import ErrorLabel from '../../../components/ErrorLabel';
import LoadingSpinner from '../../../components/LoadingSpinner';

// Form Reducer
import formField from '../../../functions/formField';
import formReducer from '../../../functions/formReducer';
import formValidator from '../../../functions/formValidator';

const initialState = {
    status: formField('', [3, 25]),
    deliveryDate: formField('', [4, 25], 'date'),
    partName: formField('', [3, 30]),
    reason: formField('', [5, 150])
};

const StatusChangeModal = (props) => {
    const [state, dispatch] = useReducer(formReducer, initialState);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const assignErrorMessage = (msg) => {
        setErrorMessage(msg);
    }

    const cleanupFunc = () => {
        dispatch({ type: 'CLEAR', default: initialState });
        setErrorMessage('');
    }

    const changeStatus = async (cb) => {
        // Start Loading Spinner
        setLoading(true);

        // Do different things depending on the status
        switch (state.status.value) {
            case 'ordered': {
                const validationState = {
                    status: { ...state.status },
                    deliveryDate: { ...state.deliveryDate },
                    partName: { ...state.partName }
                };

                // Check if it is valid
                if (!formValidator(validationState, dispatch)) {
                    props.changeStatus('CHANGE_STATUS', {
                        status: state.status.value,
                        deliveryDate: state.deliveryDate.value,
                        partName: state.partName.value,
                    }, cb);
                }
            } break;
            case 'repairing':
            case 'ready':
            case 'delivered':
                props.changeStatus('CHANGE_STATUS', {
                    status: state.status.value
                }, cb);
                break;
            case 'failed':
            case 'canceled': {
                const validationState = {
                    status: { ...state.status },
                    reason: { ...state.reason }
                };

                // Check if it is valid
                if (!formValidator(validationState, dispatch)) {
                    props.changeStatus('CHANGE_STATUS', {
                        status: state.status.value,
                        reason: state.reason.value
                    }, cb);
                }
            } break;
            default:
                console.debug(`Status '${state.status.value}' not supported`)
        }

        // Remove Loading Spinner
        setLoading(false);
    };

    const onInputStatusChanged = (e) => {
        setErrorMessage('');
        dispatch({ type: 'UPDATE', param: 'status', value: e.target.value });
    }

    return (
        <Modal show={props.show} onHide={props.onClose} onShow={cleanupFunc}>
            <Modal.Header>
                <Modal.Title>Cambia el Estado de la Orden</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label className={styles.Label}>Estado</Form.Label>
                        <Form.Control
                            as="select"
                            onChange={onInputStatusChanged}
                            size="lg"
                            value={state.status.value} custom>
                            <option value=''>Seleciona una opci&oacute;n</option>
                            <option value='ordered'>Encargado</option>
                            <option value='repairing'>Reparando</option>
                            <option value='ready'>Listo</option>
                            <option value='failed'>No Se Pudo</option>
                            <option value='delivered'>Entregado</option>
                            <option value='canceled'>Cancelado</option>
                        </Form.Control>
                    </Form.Group>
                    {state.status.value === 'ordered' &&
                        <>
                            <Form.Group>
                                <Form.Label className={styles.Label}>Dia de Llegada del paquete</Form.Label>
                                <Form.Control
                                    size="lg"
                                    type="date"
                                    min={new Date().toISOString().split('T')[0]}
                                    isInvalid={state.deliveryDate.hasError}
                                    onChange={(e) => dispatch({ type: 'UPDATE', param: 'deliveryDate', value: new Date(e.target.value).getTime() })} />
                                <Form.Control.Feedback type="invalid" >{state.deliveryDate.errorMessage}</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label className={styles.Label}>Nombre de la parte</Form.Label>
                                <Form.Control
                                    size="lg"
                                    type="text"
                                    isInvalid={state.partName.hasError}
                                    onChange={(e) => dispatch({ type: 'UPDATE', param: 'partName', value: e.target.value })} />
                                <Form.Control.Feedback type="invalid" >{state.partName.errorMessage}</Form.Control.Feedback>
                            </Form.Group>
                        </>
                    }
                    {(['failed', 'canceled'].includes(state.status.value)) && <Form.Group>
                        <Form.Label className={styles.Label}>Por que razón este estado?</Form.Label>
                        <Form.Control
                            size="lg"
                            as="textarea"
                            isInvalid={state.reason.hasError}
                            onChange={(e) => dispatch({ type: 'UPDATE', param: 'reason', value: e.target.value })} />
                        <Form.Control.Feedback type="invalid" >{state.reason.errorMessage}</Form.Control.Feedback>
                    </Form.Group>}
                </Form>
                <ErrorLabel>{errorMessage}</ErrorLabel>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={props.onClose}>Cancelar</Button>
                <Button
                    variant="primary"
                    onClick={() => changeStatus(assignErrorMessage)}
                    disabled={(state.status.value === '') && !loading}>
                    <span>Cambiar Estado</span>
                    {loading && <LoadingSpinner size="sm" inButton />}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default StatusChangeModal;